/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_Screen_ReaderInputs */

const en_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screen reader support (ARIA attributes, route announcements)`)
};

const de_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung von Bildschirmlesegeräten (ARIA-Attribute, Routenankündigungen)`)
};

const fr_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support lecteur d'ecran (attributs ARIA, annonces de routes)`)
};

const es_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte de lector de pantalla (atributos ARIA, anuncios de ruta)`)
};

const it_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto screen reader (attributi ARIA, annunci di percorso)`)
};

const nl_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermlezerondersteuning (ARIA-attributen, routeaankondigingen)`)
};

const pl_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsluga czytnikow ekranu (atrybuty ARIA, komunikaty o trasach)`)
};

const fi_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruudunlukijatuki (ARIA-attribuutit, reittailmoitukset)`)
};

const da_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skaermlaeserstotte (ARIA-attributter, rutemeddelelser)`)
};

const sv_a11y_statement_accessible_screen_reader = /** @type {(inputs: A11y_Statement_Accessible_Screen_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skarmlasarstod (ARIA-attribut, ruttmeddelanden)`)
};

/**
* | output |
* | --- |
* | "Screen reader support (ARIA attributes, route announcements)" |
*
* @param {A11y_Statement_Accessible_Screen_ReaderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_screen_reader = /** @type {((inputs?: A11y_Statement_Accessible_Screen_ReaderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_Screen_ReaderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "es") return es_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "it") return it_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "da") return da_a11y_statement_accessible_screen_reader(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_screen_reader(inputs)
	return en_a11y_statement_accessible_screen_reader(inputs)
});